/**
 * * Типы группировок
 */
export enum TasksKanbanGrouppingTypeEnum {
  /**Статус */
  Status = 0,
  /**Исполнитель */
  Performer = 1,
  /**Приоритет */
  Priority = 2,
  /**Тип */
  Type = 3,
  /**Тег */
  Tag = 4,
  /**Автор */
  Author = 5,
  /**Без группировки */
  None = 6,
}
